import React from "react";

export const ContactPage = () => {
  return (
    <main>
      <h1 style={{ textAlign: 'center', marginTop: '50px', display: 'flex', justifyContent: 'center', color: '#496a86', fontFamily: 'cursive', fontSize: '40px' }}>Get in Touch</h1>
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <iframe src="https://docs.google.com/forms/d/1vP0df4q3wsXgaKObZK4lBCad68LvJy7XdoUtR978vjc/viewform?embedded=true" width="700" height="1150" title="Booking Form">Loading…</iframe>
      </div>
    </main>
    
  )
}

export default ContactPage;